export const RightArrowicon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={6}
            height={10}
            viewBox="0 0 6 10"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.19527 0.309998L0.252457 1.25281L3.78105 4.7814L0.252457 8.31L1.19527 9.25281L5.66667 4.7814L1.19527 0.309998Z"
                fill="#FCFCFC"
                fillOpacity="0.4"
            />
        </svg>
    )
}